import * as v from 'valibot';

export const EVENT_STATUS = ['ACCEPTED', 'TENTATIVE', 'DECLINED'] as const;
export const EventStatusScheme = v.picklist(EVENT_STATUS);

export const EventSchema = v.object({
  channel: v.nullish(v.string()),
  cid: v.nullish(v.string()),
  state: v.nullish(EventStatusScheme),
  updated: v.nullish(v.number()),
});

export type TEventStatus = v.Output<typeof EventStatusScheme>;
export type TEvent = v.Output<typeof EventSchema>;
